// Parecer humano (COM-05, COM-06).
//
// justificativa fica cifrada (DEK do caso + AAD=caseId). conflitoDeclarado é
// condition para o membro acessar GET /cases/:id (D-79 412 se ainda não declarou).

export const VOTOS = ['procedente', 'improcedente', 'improcedente_insuficiencia'] as const;
export type Voto = (typeof VOTOS)[number];

/** Autor do parecer (v2). IA-Analista é o 4º membro com voto que conta (R1). */
export type AutorParecer = 'humano' | 'ia_analista';

/** memberId reservado da IA-Analista quando ela vota como 4º membro (v2). */
export const IA_ANALISTA_MEMBER_ID = 'ia-analista';

export interface Parecer {
  readonly memberId: string; // userUlid
  readonly voto: Voto;
  readonly justificativaCiphertext: string; // base64
  readonly nonce: string; // base64
  readonly conflitoDeclarado: boolean;
  readonly emittedAt: number;
  /**
   * v2 (aditivo, opcional p/ back-compat): distingue parecer humano do da
   * IA-Analista. Ausente ⇒ tratado como 'humano' (ver parecerAutor). Pareceres
   * legados (sem o campo) permanecem válidos e contam como humanos.
   */
  readonly autor?: AutorParecer;
}

/** Autor efetivo do parecer — ausente ⇒ 'humano' (back-compat legado). */
export function parecerAutor(p: Parecer): AutorParecer {
  return p.autor ?? 'humano';
}
